module.exports = __webpack_public_path__ + "static/media/service-img-19.eaa1804a.jpg";